import React, { createContext, useState, useContext, useEffect } from 'react';
import commonApi from '../utils/api';
import { CommonContext } from './CommonContext';

export const ChannelContext = createContext();

export const ChannelContextProvider = ({ children }) => {
    const { user, setOpenAlert, setSeverity, setAlertMessage } = useContext(CommonContext);

    const initialFilters = { searchBy: 'channel_name', searchValue: '' };
    const [filters, setFilters] = useState(initialFilters);

    const [addModal, setAddModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [firstLoading, setFirstLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [viewData, setViewData] = useState(null);
    const [allPickupRequest, setAllPickupRequest] = useState([]);
    const [allData, setAllData] = useState([]);
    const [openAlert, setOpenAlertLocal] = useState(false);
    const [alertMessage, setAlertMessageLocal] = useState('');
    const [severity, setSeverityLocal] = useState('success');

    // AddChannel.js expects these names specifically
    const setAlertMesaage = (msg) => {
        setAlertMessageLocal(msg);
        setAlertMessage(msg);
    };

    const setOpenAlertMapped = (val) => {
        setOpenAlertLocal(val);
        setOpenAlert(val);
    };

    const setSeverityMapped = (val) => {
        setSeverityLocal(val);
        setSeverity(val);
    };

    const handleAddModal = () => {
        setAddModal(true);
    };

    const handleCloseModal = () => {
        setAddModal(false);
        setViewData(null);
        setIsEdit(false);
    };

    const onLoadApi = (merchantId = null) => {
        setIsLoading(true);
        setFirstLoading(false);

        let payload = {};
        if (user?.user_type === "Merchant") {
            payload.merchant_id = user?.id;
        } else if (merchantId) {
            payload.merchant_id = merchantId;
        }

        commonApi.post('channel-integration/get-channel-setup', payload)
            .then((response) => {
                setIsLoading(false);
                setFirstLoading(true);
                if (response?.data?.data) {
                    setAllPickupRequest(response?.data?.data);
                    setAllData(response?.data?.data);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setFirstLoading(true);
                console.error('Error fetching channels:', error);
            });
    };

    const contextValue = {
        addModal,
        setAddModal,
        handleAddModal,
        handleCloseModal,
        isLoading,
        setIsLoading,
        firstLoading,
        isEdit,
        setIsEdit,
        viewData,
        setViewData,
        allPickupRequest,
        setAllPickupRequest,
        allData,
        setAllData,
        filters,
        setFilters,
        initialFilters,
        onLoadApi,
        openAlert: openAlert,
        setOpenAlert: setOpenAlertMapped,
        alertMessage: alertMessage,
        setAlertMesaage,
        severity: severity,
        setSeverity: setSeverityMapped,
    };

    return (
        <ChannelContext.Provider value={contextValue}>
            {children}
        </ChannelContext.Provider>
    );
};
